/**
 * Privacy Policy Memoized
 */

import {
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { ModalTypes } from "../../config/types/modals";
import { PrimaryButton } from "../base/atoms/HJSButton";

interface IModalComponentProps {
  changeModalType: (modalType: ModalTypes) => void;
}

const PrivacyPolicy = React.memo(
  ({ changeModalType }: IModalComponentProps) => {
    return (
      <ModalContent
        px={{ base: 0, md: 6 }}
        py={4}
        maxHeight="90vh"
        overflow="auto"
      >
        <ModalHeader px="1rem !important">
          <Heading as="h2" fontSize={[20, 20, 30, 40]} color="teal.900">
            Privacy Policy
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={6} mt={4} alignItems="flex-start">
            <Text
              aria-readonly={true}
              color="hjsBlack"
              fontSize={[14, 14, 16]}
              fontWeight="500"
            >
              We will never share your information. Your information is secure
              and any data you share within surveys is anonymized before it is
              used in our study. You can read more about the study on the About
              page.
            </Text>
            <Text
              aria-readonly={true}
              color="hjsBlack"
              fontSize={[14, 14, 16]}
              fontWeight="500"
            >
              Also note that we will never email you more than once a week. If
              you subscribe to text message surveys you will never receive more
              than one survey per week, and we will never contact you after the
              conclusion of the study.
            </Text>
            <Text
              aria-readonly={true}
              color="hjsBlack"
              fontSize={[14, 14, 16]}
              fontWeight="500"
            >
              You may unsubscribe from all emails and text messages at any time.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter alignItems="center" justifyContent="center">
          <PrimaryButton
            my={4}
            onClick={() => changeModalType(ModalTypes.LOGIN)}
          >
            Got it!
          </PrimaryButton>
        </ModalFooter>
      </ModalContent>
    );
  }
);
PrivacyPolicy.displayName = "PrivacyPolicy";

export default PrivacyPolicy;
